import React from "react"
import "./style.css"


export default function QMSHelpFooter() {
    return (
        <div className="qms-help-footer">
            <p><strong>Need help?</strong></p>
            <p>For questions about the QMS: <a href="mailto:">qms_support@genesisrg.com</a></p>
            <p>For technical questions about this platform: <a href="mailto:">support@genesisrg.com</a></p>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/routes/qms-training/QMSTraining/QMSHelpFooter.js